// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"811":"faf31f0afbadb0f1","1690":"d62ef821f2a8e3fb"}[chunkId] + ".css";
};